<template>
  <div class="activityFile common_group">
    <div class="title">
      <img src="@/assets/images/fileIcon.png">
      <span>{{ $t('file.aa') }}</span>
    </div>
    <div class="wrapper">
      <el-upload class="upload" :action="baseUrl" :before-upload="beforeUpload" :on-success="handleSuccess"
        :on-progress="uploadVideoProcess" multiple :disabled="btnDisabled" :show-file-list="false">
        <div>
          <el-button type="primary" :disabled="btnDisabled"><i class="iconfont icon-shangchuan-icon1" />{{ $t('file.ctu') }}</el-button>
          <span slot="tip">{{ $t('file.F10M') }}</span>
        </div>
      </el-upload>
      <ul class="fileList">
        <li v-for="(item, index) in fileList" :key="index">
          <i class="iconfont icon-a-fujian-iconkaobei" />
          <span>{{ item.name }}</span>
          <i class="iconfont icon--s-guanbi closeIconFont" v-show="!progressFlag" @click="beforeRemove(index)" />
          <el-progress v-if="index === fileList.length - 1 && progressFlag" :percentage="loadProgress" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';
// import { drafts } from '@/views/activitieList/service';

export default {
  data() {
    return {
      loadProgress: 0,
      progressFlag: false,
      btnDisabled: false,
      fileList: [],
      baseUrl: window._env_.VUE_APP_FILESERVICE_URL // 'https://fileserviceoutside.ruijie.com.cn/api/file/marketActivity/15008559650934784/15008559650934784'
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    validateHandler() {
      let result = true;
      if (this.fileList.length > 0) {
        let messageInfo = '';
        result = this.fileList.every(item => {
          if (!((item.response && item.response.data[0].FID) || item.fileId)) {
            messageInfo = item.name ? `${item.name} ${this.$t('file.FPdar')}` : this.$t('file.FPdaua');
          }
          return (item.response && item.response.data[0].FID) || item.fileId;
        });
        if (!result) this.$message.error(messageInfo);
      }
      return result;
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        let fileSize = file.size / 1024 / 1024 < 10;
        if (!fileSize) {
          this.$message.error(this.$t('file.uFn10M'));
          reject(new Error(this.$t('file.uFn10M')));
          return false;
        }
        newApplicationFormApi.getFileToken().then(res => {
          if (res.status === '200') {
            if (this.baseUrl.indexOf('?Token=') < 0) {
              this.baseUrl = this.baseUrl + '?Token=' + res.data;
            }
            this.loadProgress = 0;
            this.fileList.push({
              name: file.name
            });
            resolve();
          } else {
            reject(res.status);
          }
        });
      });
    },
    uploadVideoProcess(event, file, fileList) {
      this.progressFlag = true;
      if (event.percent >= 100) {
        let interval = setInterval(() => {
          this.loadProgress += 20;
          if (this.loadProgress >= 99) {
            this.loadProgress = 99;
            clearInterval(interval);
          }
        }, 100);
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.status === '200' && response.data[0].FID) {
        this.loadProgress = 100;
        let fileIndex = this.fileList.findIndex(item => item.name === response.data[0].FullName);
        this.fileList[fileIndex].fileId = response.data[0].FID;
        setTimeout(() => {
          this.progressFlag = false;
        }, 800);
      } else {
        this.fileList.splice(this.fileList.length - 1, 1);
        this.progressFlag = false;
        this.$message.error(response.err);
      }
      this.baseUrl = this.baseUrl.split('?Token')[0];
    },
    beforeRemove(index) {
      // 如果文件删除成功则报错
      this.fileList.splice(index, 1);
      // if (file && file.status === 'success') {
      //   this.fileList = fileList;
      //   this.$message({
      //     type: 'success',
      //     message: '删除成功!'
      //   });
      // }
    }
  },
  mounted() {
    if (this.$store.state.newApplication.editFlag === 3) {
      this.btnDisabled = true;
    }
    if (this.$route.query.activityCode) {
      this.fileList = this.editEchoData.attachFileList.map(item => {
        item.name = item.fileName;
        return item;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';

.activityFile {
  >.wrapper {
    background: #FCFDFE;
    border: 1px solid #DEE1E7;
    line-height: 30px;
    position: relative;
    @extend .clear;

    &:before {
      content: '';
      background: #FFFFFF;
      width: 100%;
      height: 1px;
      position: absolute;
      top: 0;
      left: 0;
    }

    >ul {
      >li {
        padding: 15px 0 15px 20px;
        border-top: 1px solid #E2E4E9;
        height: 20px;
        line-height: 20px;
        box-sizing: content-box;

        >i:first-child {
          font-size: 18px;
          margin-right: 15px;
          color: #B8B8B8;
        }

        >span {
          margin-right: 40px;
        }

        >.closeIconFont {
          display: none;
          vertical-align: middle;
          font-size: 16px;
          cursor: pointer;
          color: #dc5650;
        }

        &:hover>.closeIconFont {
          display: inline-block;
        }

        >.el-progress {
          width: 300px;
          display: inline-block;
        }
      }
    }

    ::v-deep>.upload {
      >.el-upload {
        padding: 20px;

        >div>span {
          margin-left: 10px;
          color: #5B646E;
        }
      }
    }
  }
}
</style>
